var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-block"},[_c('footer',{staticClass:"footer"},[_vm._v("\r\n        Ver. "+_vm._s(_vm.ver)+" Copyright © NIPPON EXPRESS, All rights reserved\r\n        ")])])}
var staticRenderFns = []

export { render, staticRenderFns }